import { joinCn } from '../util';

const style = {
  chip: joinCn(
    'flex items-center justify-center gap-1',
    'max-w-full',
    'rounded-md px-2 py-1',
    'text-body-s font-normal text-black',
    'bg-tertiary-200',

    'enabled:hover:shadow-sm',

    'aria-disabled:bg-gray-200',
  ),

  get error() {
    return joinCn(this.chip, 'bg-error-500-active');
  },

  text: joinCn('inline-block w-full truncate'),

  deleteIcon: joinCn(
    'h-4 w-4 cursor-pointer',
    'text-gray-500',

    'aria-disabled:text-gray-300',
  ),
};

export default style;
